import React, { PureComponent } from "react";
import TextField from '@material-ui/core/TextField';
import styles from "./style.css";

export default class UQFormsTextField extends PureComponent {
  render() {
    const { labelClassName, error, ...other } = this.props;
    const margin = this.props.margin ? this.props.margin : 'normal';
    const errorProps = error != null ? {
      error: true,
      helperText: error
    } : {};
    return (
      <TextField
        {...errorProps}
        {...other}
        margin={margin}
        className={styles.container}
        InputLabelProps={{ className: `${styles.label} ${labelClassName || ''}`, classes: { shrink: styles.labelShrink } }}
        InputProps={{ className: styles.input }}
      />
    );
  }
}

